import { createSelector } from "reselect";
import { getPageContent } from "shared/selectors/base";

// eslint-disable-next-line import/prefer-default-export
export const getCustomFields = createSelector(
  [getPageContent],
  pageContent => pageContent.custom_fields
);
